<div class="govuk-width-container d-flex">
    <gb-ui-header
      [imageDetail]="imageDetail"
      [navLinks]="navigation"
      [showSearch]="false"
      (searchTerm)="search($event)"
    >
      <ng-template #utilityArea>
        <div class="d-flex">
          @if (!isAdmin() && showLoginButton) {
          <button class="btn btn-primary login" (click)="login()">
            Log in
          </button>
          }
        </div>
      </ng-template>
    </gb-ui-header>
  </div>
  